/* allmodule 子模块 */
import Common from '@/store/modules/common'
const AllModuleConfig = {
  Common
}

export default AllModuleConfig
